import React from 'react'
import './TaskViews.scss'

interface HabitsViewProps {
  lifeSpace?: 'personal' | 'work' | 'home' | 'all'
}

export const HabitsView: React.FC<HabitsViewProps> = () => {
  return (
    <div className="task-view">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">Gewohnheiten</h2>
        </div>
      </div>
    </div>
  )
}
